import { PRODUCTS_BY_CATEGORY, WIX_PAYMENT_PROVIDER_ID } from '../../consts';

export function normalizeProducts(category: string) {
  return PRODUCTS_BY_CATEGORY[category].map((product) => product.name);
}

export function isWixPaymentProviderSupported(paymentAggregators: { providers?: { id: string }[] }) {
  const providers = paymentAggregators?.providers || [];
  const isSupported = providers.some((provider) => provider.id === WIX_PAYMENT_PROVIDER_ID);
  return isSupported;
}
